// require('html5-notification/dist/Notification.js')
// require('./firebase-messaging')

require('./app')



// WEBPACK FOOTER //
// ./src/main.js